import { useContext, useMemo } from "react";
import { TenantContext } from "../context/TenantContextProvider";
import { AvailableIntegrations } from "../models/OrganisationModels";
import { useTenants } from "./useTenants";
import { useOrganisationConfigurations } from "./useOrganisationConfigurations";

export default function useFeatureToggles() {
  const { tenants } = useTenants();
  const { tenant: currentTenantId } = useContext(TenantContext);
  const { configurations } = useOrganisationConfigurations();

  const currentTenant = useMemo(() => tenants.find((t) => t.id === currentTenantId), [tenants, currentTenantId]);

  const isInvoiceUploadEnabled = useMemo(
    () => currentTenant?.documentIntegrationSource === AvailableIntegrations.AttelasStorage,
    [currentTenant?.documentIntegrationSource]
  );

  const isDisputedEnabled = useMemo(
    () => currentTenant?.integrationSource === AvailableIntegrations.Dynamicsfo,
    [currentTenant?.integrationSource]
  );

  const isPromiseToPayEditEnabled = useMemo(
    () => currentTenant?.integrationSource === AvailableIntegrations.Xero,
    [currentTenant?.integrationSource]
  );

  return {
    isWorkflowEnabled: !!configurations?.workflowEnabled,
    isInvoiceUploadEnabled,
    isDisputedEnabled,
    isPromiseToPayEditEnabled,
  };
}
